
  <mat-dialog-content class="grades-dialog setup" style="overflow: hidden; scroll-behavior: unset;">
        
    <ng-container *ngIf="!data?.isGradeEdit || data?.setupAccountImposed">
      <div class="step-container cursor-pointer assessment_mt-25" (click)="showStep1()">
        <img src="assets/img/back-arrow-icon-dark.svg" class="back"><div class="step">STEP 2/3</div>
      </div>
      
      <div class="msg-one assessment_mt-25">
        {{ data?.message }}
      </div>
      <div class="info-div">
        {{data?.message2}}
      </div>
  
    </ng-container>
    
    <!-- <div class="info-div" *ngIf="data?.isGradeEdit">
      {{data?.message3}}
    </div> -->
    


    <div class="text-02">What grade are you in?</div>
        <div class="grades-box">
            <div class="grade-box {{selectedGrade && selectedGrade.name && (selectedGrade.name === gr.name) ? 'selected': ''}}" (click)="saveIndex(gr,data.isGradeEdit)" *ngFor="let gr of grades">
              {{gr.name}}
            </div>
        </div>

      <ng-container *ngIf="data?.isGradeEdit && !data?.setupAccountImposed && selectedGrade && selectedGrade.name && (selectedGrade.name=='11th' || selectedGrade.name=='12th' || selectedGrade.name=='13th')">
        <div class="text-02 assessment_mt-25">Please select your stream</div>
        <div class="grades-box stream">
          <div *ngFor="let stream of streams" [class.selected]="selectedStream==stream.streamId" (click)="onStreamClick(stream.streamId)"  class="grade-box" > {{stream.name}}</div>
        </div>
      </ng-container>

      <div class="m-bottom-btn d-flex justify-content-md-end assessment_mt-25" *ngIf="data?.isGradeEdit">
          <button type="button" [disabled]="!selectedGrade" class="btn btn-primary btn-save-details" (click)="onConfirmClick()">SAVE DETAILS</button>
          <button *ngIf="!data?.setupAccountImposed" type="button" style="color: #0C9968;" class="ASM_no-box-shadow btn btn-link assessment_mb-0 assessment_pr-30 assessment_pl-30" (click)="onNoClick()">Cancel</button>
      </div>

  </mat-dialog-content>
